<template>
  <div style="background: #f4f4f4;">
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
      @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="gift-bg"></div>
    <div class="gift-content-title">
      当前位置:
      <span><a @click="enterHome">平台首页</a> > </span>
      <span><a @click="enterGift">礼包</a> > </span>
      <span v-show="enterTypeState">
        <a :href="gameDevice == 1 ? '/webOfficial/'+gameTag : '/mobileOfficial/'+gameTag" target="_blank">{{gameName}}</a> > 
      </span>
      <span v-show="enterTypeState">{{gameName}}礼包</span>
      <span v-show="!enterTypeState">{{giftName}}</span>
    </div>
    <div class="gift-content-body">
      <div class="gift-left-body">
        <a :href="gameDevice == 1 ? '/webOfficial/'+gameTag : '/mobileOfficial/'+gameTag" target="_blank" class="gift-img">
          <img :src="baseImageAddress+'type=small&game_tag='+gameTag" v-bind:alt="gameName">
        </a>
        
        <div class="gift-box">
          <h2>
            <a :href="gameDevice == 1 ? '/webOfficial/'+gameTag : '/mobileOfficial/'+gameTag" v-bind:title="gameName" target="_blank">{{gameName}}</a>
          </h2>
          <div class="gift-start">
            <a :href="gameDevice == 1 ? '/webOfficial/'+gameTag : '/mobileOfficial/'+gameTag" class="gift-start-a" target="_blank">进入官网</a>
            <b>使用方法:</b>
            <p>{{hasGift ? '福利-激活码' : '暂时无礼包'}}</p>
          </div>
          <dl v-for="(dl,index) in gifts" :key="index">
            <dt>
              <h6><span class="pt">{{getGiftIcon(dl.gift_type)}}</span>{{dl.gift_name}}</h6>
              <span class="gift-dt-span">
                <em>礼包剩余: </em>
                <Progress :percent="getPercent(dl.gift_count,dl.gift_max,0)" class="gift-progress-bar">
                  <span>{{getPercent(dl.gift_count,dl.gift_max,1)}}</span>
                </Progress>
              </span>
              <p>
                <em>礼包内容: </em>
                {{dl.gift_content}}
              </p>
            </dt>
            <dd>
              <a @click="showGiftCode(dl.gift_code,dl.gift_name)" v-show="dl.gift_receive == 1">查看</a>
              <a @click="getGiftCode(dl)" target="_blank" v-show="dl.gift_receive == 0">领取</a>
            </dd>
          </dl>
        </div>
      </div>
      <RecommendSide></RecommendSide>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
    <div v-show="showCodeState" class="pop-mask"></div>
    <div v-show="showCodeState" class="pop-body">
      <h5>{{gameName}}-{{gift.name}}</h5>
      <ul>
        <li>
          <span>礼包码:&nbsp;&nbsp;&nbsp;</span>
          <div>{{gift.code}}</div>
          <em class="gift-copy" :data-clipboard-text="gift.code" @click="copyGift('gift-copy')">复制礼包码</em>
        </li>
        <li>
          <p>请尽快使用! 请勿将礼包码透露给其他人!</p>
        </li>
        <li>
          <a @click="enterGame">开始玩</a>
        </li>
      </ul>
      <div class="pop-mode">
        <h6>礼包使用方法: </h6>
        <p>福利-激活码</p>
      </div>
      <img class="pop-close" src="../../assets/image/close.png" alt="关闭" @click="closePop">
    </div>
    <div class="tips-body" v-show="showTipsState">
      <div></div>
      <p>{{tipsMessage}}!</p>
    </div>
    <div class="suspend-tip-box" v-if="tipState">
      <div class="suspend-tip-mask"></div>
      <div class="suspend-tip-body">
        <div class="modal-header">
          <h1 style="font-size: 20px;color: #000;">提示</h1>
          <span class="modal-close" @click="closeTipModal">×</span>
        </div>
        <div class="modal-body" style="width: 100%;">
          <span class="modal-msg">{{tipMsg}}</span> 
          <div class="modal-button" @click="closeTipModal">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Footer from '../../components/common/Footer';
  import Header from '../../components/common/Header';
  import RecommendSide from '../../components/RecommendSide';
  import SuspendSide from '../../components/SuspendSide.vue';
  import SuspendMember from '../../components/SuspendMember';
  import Clipboard from "clipboard";
  export default {
    computed:{
      gifts(){
        return this.$store.state.giftDetails.gifts;
      },
      hasGift(){
        return this.$store.state.giftDetails.hasGift;
      },
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      gameName(){
        return this.$store.state.giftDetails.gameName;
      },
      gameGid(){
        return this.$store.state.giftDetails.gameGid;
      },
      giftName(){
        return this.$store.state.giftDetails.giftName;
      },
      gameDevice(){
        return this.$store.state.giftDetails.gameDevice;
      },
      gameTag(){
        return this.$store.state.giftDetails.gameTag;
      },
      GameTransfer(){
        return this.$store.state.constant.GameTransfer;
      },
      webSite(){
        return this.$store.state.home.webSite;
      },
    },
    asyncData({store,route}){
      return store.dispatch('initGiftDetails',{gid:route.query.gid,lid:route.query.lid});
    },
    metaInfo(){
      return{
        title:"福利中心_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    data() {
      return {
        loginState:false,
        enterTypeState:false,
        showCodeState:false,
        showTipsState:false,
        tipsMessage:"",
        gift:{
          code:"",
          name:""
        },
        suspendState:false,
        suspendType:0,
        tipState:false,
        tipMsg:"",
      };
    }, 
    components: { Footer, Header, RecommendSide, SuspendSide, SuspendMember},
    mounted(){
      if(this.$route.query.lid == '0'){
        this.enterTypeState = true;
      }
      this.isExistLogin();
    },
    methods: {
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      closeTipModal(){
        this.tipState = false;
      },
      showGiftCode(value,name){
        this.showCodeState = true;
        this.gift.code = value;
        this.gift.name = name;
      },
      enterGame(){
        if(this.webSite.maintain_mode == 1){
          this.tipState = true;
          this.tipMsg = this.webSite.maintain_hint;
        }else{
          if(this.gameDevice == 1){
            if(this.loginState){
              window.open(this.$router.resolve({name:'gameEnter', query:{gid:this.gameGid,path:this.$route.path}}).href,'_blank');
            }else{
              this.handleTips("请登陆!");
            }
          }else if(this.gameDevice == 2){
            window.open(this.$router.resolve({ name: 'transfer', query: { tag: this.gameTag, type: this.GameTransfer} }).href, '_blank'); 
          }else if(this.gameDevice == 3){
            window.open(this.$router.resolve({name:'enterH5', query:{gid:this.gameGid,sid:0,path:this.$route.path,tag:this.gameTag}}).href,'_blank');
          }
        }
      },
      closePop(){
        this.showCodeState = false;
      },
      enterHome(){
        this.$router.push({path:"/"});
      },
      enterGift(){
        this.$router.push({path:`gift`});
      },
      quitLogin(value){
        this.loginState = false;
      },
      //复制到粘贴版
      copyGift(val) {
        var clipboard = new Clipboard(`.${val}`);
        clipboard.on("success", () => {
          this.handleTips("复制成功!");
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", () => {
          this.handleTips("不支持此浏览器!");
          // 释放内存
          clipboard.destroy();
        });
      },
      getPercent(count,max,type) {
        if(count == undefined){
          count = 0;
        }
        if(max == undefined){
          max = 1;
        }
        let number = (max - count) / max * 100;
        if(type == 0){
          return number; 
        }else{
          if(number > 100){
            number = 100;
          }
          if(number < 0){
            number = 0;
          }
          return (number).toFixed(2)+"%";
        } 
      },
      getGiftCode(value){
        if(this.loginState){
          this.$http.post(`/get_game_gift?lid=`+value.gift_id,{}).then(res=>{
            if(res.data.code == 2000){
              value.gift_count ++;
              value.gift_receive = 1;
              value.gift_code = res.data.data;
              this.gift.code = res.data.data;
              this.gift.name = value.gift_name;
              this.showCodeState = true;
            }else{
              this.handleTips(res.data.msg);
            } 
          })
        }else{
          this.enterLogin();
        }
      },
      enterLogin(){
        this.changeSuspendType(0);
        this.changeSuspendState(true);
      }, 
      isExistLogin(){
        let token = window.sessionStorage.getItem("token");
        let state = window.sessionStorage.getItem("login_state");
        if(token != null && state){
          this.loginState = true;
        }else{
          this.loginState = false;
        }
      },
      getGiftIcon(value){
        if(value == 1){
          return "积分";
        }else if(value == 2){
          return "平台币";
        }else if(value == 3){
          return "vip";
        }else if(value == 4){
          return "免费";
        }
      },
      handleTips(value){
        this.tipsMessage = value;
        this.showTipsState = true;
          setTimeout(()=>{
            this.showTipsState = false;
          },"3000");
      }
    }
  }
</script>
<style scoped src="../../assets/css/gift.css"></style>
<style scoped>
  .gift-left-body{
    padding: 15px 20px;
  }
</style>
